<template>
  <div class="block" v-loading.fullscreen.lock="loading">
    <subHeader
      :title="service.title"
      :subtitle="service.description"
      :img_header="service.img"
    ></subHeader>

    <div class="container ptb-100">
      <div class="row">
        <div class="col-sm-3 d-none d-md-block">
          <steps :step="step_current" :steps="steps_collection"></steps>
        </div>
        <div class="col-sm-6">
          <ClubPark
            v-if="step_current == 0"
            :listSeats="listSeats"
            @resClub="resClub"
          ></ClubPark>

          <Plan
            v-if="step_current == 1"
            :club="seat"
            :setPlan="producto"
            @resVolver="resVolver"
            @resPlan="resPlan"
          ></Plan>

          <Abonado
            v-if="step_current == 2"
            :producto="producto"
            @resVolver="resVolver"
            @resAbonado="resAbonado"
          ></Abonado>

          <Facturacion
            v-if="step_current == 3"
            :abonado="abonado"
            @resVolver="resVolver"
            @resFact="resFact"
          ></Facturacion>
        </div>
        <div class="col-sm-3 d-none">Resumen</div>
      </div>
    </div>
  </div>
</template>

<script>
//components
import subHeader from "@/components/common/subHeader";
import steps from "@/components/common/Steps";
import ClubPark from "@/components/common/ClubPark";
import Plan from "./Plan";
import Abonado from "./Abonado";
import Facturacion from "./Facturacion";

//services
import services from "@/services/services.service";
import moment from "moment";

export default {
  name: "Abonados",
  components: {
    subHeader,
    steps,
    ClubPark,
    Plan,
    Abonado,
    Facturacion,
  },
  data: () => ({
    loading: false,
    service: {},
    step_current: 0,
    steps_collection: [],
    listSeats: [],
    seat: {},
    producto: {},
    abonado: {},
    form: {},
  }),
  methods: {
    showError(message) {
      this.$alert(message, "Aviso", {
        confirmButtonText: "Entendido",
        type: "warning",
        center: true,
      });
    },

    async init() {
      this.loading = true;
      this.steps_collection = [];
      await services
        .get("abonados")
        .then((res) => {
          this.service = res.data.details;
          this.steps_collection = JSON.parse(res.data.details.steps);

          axios
            .post(`${process.env.API2}/v1/abs/listarAreaAbonados`)
            .then((res) => {
              if (res.data.length > 0) {
                const tmp = res.data.map((item) => {
                  return {
                    idseat: item.area,
                    name: item.descripcion,
                    city: item.distrito,
                    address: item.direccion,
                    latitud: item.latitud,
                    longitud: item.longitud,
                  };
                });
                this.listSeats = tmp;
              }
              console.log(this.listSeats);
            });
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resVolver(step) {
      this.step_current = step;
    },

    resClub(club) {
      this.seat = club;
      this.step_current++;
    },

    resPlan(plan) {
      console.log(plan);
      this.producto = plan;
      this.step_current++;
    },

    resAbonado(abonado) {
      this.abonado = abonado;
      this.step_current++;
    },

    resFact(fact) {
      this.loading = true;
      this.form.st0 = this.seat;
      this.form.st1 = this.producto;
      this.form.st2 = this.abonado;
      this.form.st3 = fact;

      axios
        .post(`${process.env.API2}/v1/abs/registrarVehiculoAbonado`, {
          abonadoRegistroCabecera: {
            periodo: parseInt(moment().format("Y")),
            area: this.seat.idseat,
            producto: this.producto.idproducto,
            pUnitario: this.producto.producto,
            propietarioNombreApellido: this.abonado.firstname,
            propietarioDiTipo: this.abonado.tdocument,
            propietarioDiNumero: this.abonado.ndocument,
            propietarioCelular: this.abonado.phone1,
            propietarioFijo: this.abonado.phone2,
            propietarioDireccion: this.abonado.address,
            propietarioEmial: this.abonado.email,
            tipoSistema: "ART",
            usuarioCreate: "EAGC",
            cantidadMes: 1,
            fechaInicio: moment().format("YYYY-MM-DD[T]HH:mm:ss"),
          },
          abonadoRegistroCuerpo: [
            {
              idVehiculo: 1,
              item: 1,
              vehiculoPlaca: this.abonado.placa,
              vehiculoMarca: this.abonado.marca,
              vehiculoModelo: this.abonado.modelo,
              vehiculoColor: this.abonado.color,
              vehiculoNumeroMotor: this.abonado.motor,
            },
          ],
        })
        .then((res) => {
          if (parseInt(res.data) > 0) {
            this.form.operation = parseInt(res.data);
            axios
              .post(`${process.env.API1}/api/abonados/register`, this.form)
              .then((response) => {
                this.loading = false;
                if (response.data.status)
                  window.location.href = response.data.url;
                else alert(response.data.message);
              })
              .catch((err) => {
                this.loading = false;
              });
          } else {
            this.loading = false;
            this.showError(
              "Lo sentimos, no se ha podido registrar la información."
            );
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.init();
  },
  created() {},
};
</script>



// WEBPACK FOOTER //
// src/components/pages/abonados/Index.vue